import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import type { PhrasingContent } from 'mdast';
import type { FromPMHandlers } from '../types';
import { convertInlineChildren } from '../utils';

export function heading(
	node: PMNode,
	handlers: FromPMHandlers,
): { children: PhrasingContent[]; depth: 1 | 2 | 3 | 4 | 5 | 6; type: 'heading' } {
	const depth: 1 | 2 | 3 | 4 | 5 | 6 = (node.attrs.level ?? 1) as 1 | 2 | 3 | 4 | 5 | 6;
	const children: PhrasingContent[] = convertInlineChildren(node, handlers);
	return {
		type: 'heading' as const,
		depth,
		children,
	};
}
